import React from "react";
import {
  ITkBreadcrumbsItemProps,
  ITkBreadcrumbsProps,
} from "../../../type/componentsType/TkBreadcrumbs";
import { Breadcrumbs, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import "./_style.scss";

/**
 * パンくずリスト部品
 * ユーザの現在位置をハイパーリンクで表示する
 * @param list パンくずリスト
 * @return TkBreadcrumbs パンくずリスト部品
 */
export const TkBreadcrumbs: React.FC<ITkBreadcrumbsProps> = (props) => {
  const { list } = props;

  return (
    <Breadcrumbs aria-label="breadcrumb" className="tkBreadcrumbs">
      {list.map((item: ITkBreadcrumbsItemProps, index) => {
        const { title, href = "/", lastIndexColor = "text.primary" } = item;

        if (index === list.length - 1) {
          return (
            <Typography color={lastIndexColor} key={index}>
              {title}
            </Typography>
          );
        } else {
          return (
            <Link
              data-testid="TkBreadcurmbLink"
              className="link"
              to={href}
              key={index}
            >
              {title}
            </Link>
          );
        }
      })}
    </Breadcrumbs>
  );
};

export default TkBreadcrumbs;
